<template>
  <v-dialog v-model="active" max-width="500px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ $t('editorder.status.title') }}</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <p>{{ $t('editorder.status.new.label') }}</p>
          <v-radio-group v-model="newStatus">
            <v-radio
              v-for="radio in radioButtons"
              :key="radio"
              :label="$t('editorder.status.label.' + radio.toLowerCase())"
              :value="radio"
            ></v-radio>
          </v-radio-group>
          <p>{{ $t('editorder.status.batch') }}</p>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeDialog">
          {{ $t('app.btn.cancel') }}
        </v-btn>
        <v-btn color="blue darken-1" text @click="save" :disabled="!newStatus">
          {{ $t('app.btn.save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { mapActions, mapMutations } from 'vuex';
import { defineComponent, PropType } from 'vue';
import { Order } from '@/types/Order';
import { ORDER_STATUS } from '@/constants/order/orderStatus';

export default defineComponent({
  name: 'StatusBatchUpdateDialog',
  props: {
    orders: {
      type: Array as PropType<Array<Order>>,
      required: true,
    },
  },
  data: () => ({
    active: false,
    radioButtons: [ORDER_STATUS.DONE, ORDER_STATUS.DONE_ARCHIVED],
    newStatus: null as string | null,
  }),
  methods: {
    ...mapActions({
      updateOrderStatusBatch: 'order/updateOrderStatusBatch',
    }),
    ...mapMutations({
      onNotification: 'snackbar/onNotification',
    }),
    openDialog() {
      this.active = true;
    },
    save() {
      this.updateOrderStatusBatch({
        orderIds: this.orders.map((order) => order.id),
        status: this.newStatus,
      }).then((success) => {
        if (success) {
          this.closeDialog();
          this.onNotification({
            message: this.$t('editorder.status.save.success'),
            color: 'success',
          });
        } else {
          this.onNotification({
            message: this.$t('editorder.status.save.error'),
            color: 'error',
          });
        }
      });
    },
    closeDialog() {
      this.newStatus = null;
      this.active = false;
    },
  },
});
</script>
